import { useQuery } from '@tanstack/react-query'
import { redeemApi } from '../../utils/api'

/**
 * 自分に発行された特典コードの一覧（ProfilePage）。
 * queryKey: ['myCodes']
 *
 * useMaintenance の localStorage キャッシュ・refetchInterval・retry: 1 は踏襲しない。
 * あれは全ページのゲート判定を止めないための仕掛けで、1セクションの一覧には要らない。
 * 引き換え成功時の更新は useRedeemCode の onSuccess が invalidate で行う。
 */
export function useMyCodes() {
  return useQuery({
    queryKey: ['myCodes'],
    queryFn: () => redeemApi.mine(),
    staleTime: 60_000,
  })
}
